import { render, staticRenderFns } from "./InstructionsItem.vue?vue&type=template&id=06bdbc5c&scoped=true&"
import script from "./InstructionsItem.vue?vue&type=script&lang=js&"
export * from "./InstructionsItem.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=06bdbc5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bdbc5c",
  null
  
)

export default component.exports